// extracted by mini-css-extract-plugin
export default {"footer":"footer_footer__XXj-R","decorativeLine":"footer_decorativeLine__ULcyd","content":"footer_content__Px8MT","bottom":"footer_bottom__boStR"};